import React from "react";
import "./Footer.css";
import logo from "../logo/logo.svg";

function Footer() {
  return (
    <footer className="footer-detail-container">
      <div className="footer-detail-container--inner center-box">
        <div className="footer-detail-top--inner flex-row">
          <img className="footer-detail-logo" src={logo} alt="ロゴ画像" />
          <div className="copy-detail arial">© 2022 Kaito</div>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
